/* eslint-disable react/prop-types */
import CategoriesNav from "components/CategoriesNav";

const CATEGORIES = [
  {
    id: "202",
    title: "Stories",
    slug: "stories",
    groupHandle: "articleCategories",
    subTitle: "Guest Mob, Street Mob, Articles and more.",
    summary:
      "The place for Mob's latest news, food trends, guest appearances, and the hottest street vendors.",
  },
  {
    id: "25453",
    title: "Green",
    slug: "green",
    groupHandle: "articleCategories",
    subTitle: "Articles & tips to help you live more sustainably.",
    summary:
      "Ways to live more sustainably around food and in the kitchen. Tips for shopping sustainably, reducing food waste and things to avoid or try.",
  },
  {
    id: "205",
    title: "Tips",
    slug: "tips",
    groupHandle: "articleCategories",
    subTitle: "Our ultimate kitchen hacks.",
    summary:
      "Mob's ultimate student tips to make the most of your ingredients before throwing expensive ingredients away.",
  },
];

const ArticleCategoriesNav = () => (
  <CategoriesNav
    categories={CATEGORIES}
    parentLinks={[
      {
        href: "/life",
        label: "Latest",
      },
      {
        href: "/life/premium",
        label: "Member Exclusives",
      },
    ]}
  />
);

export default ArticleCategoriesNav;
